<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$l('tab_order_statistics') || '订单统计'"
        name="base"
      >
        <ReportIndex />
      </el-tab-pane>
      <el-tab-pane :label="$l('tab_order_list') || '订单明细'" name="orderList">
        <page-table />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ReportIndex from './components/report'
import PageTable from './components/table/index.vue'
export default {
  name: 'order-dashboard',
  components: {
    ReportIndex,
    PageTable,
  },
  data() {
    return {
      activeName: 'base',
    }
  },
}
</script>

<style></style>
